import { createGlobalStyle, css } from 'styled-components'

export const HpxGlobalStyleOverride = createGlobalStyle`
  && {
    ${({ theme: { isHpx, color } }) =>
      isHpx &&
      css`
        body {
          .instant-ink-enroll-hpx-button-override {
            &[disabled] {
              color: #ffffff;
            }
          }
          .instant-ink-enroll-hpx-button-override-checkout {
            &[disabled] {
              background-color: #edeefe;
            }
          }
          .instant-ink-enroll-hpx-secondary-button-override {
            &:not([disabled]) {
              color: ${color.foreground.default};
              border-color: ${color.stroke.informative.default};

              &:hover {
                color: ${color.foreground.default};
                border-color: ${color.stroke.informative.default};
              }

              &:active {
                background-color: ${color.primary.background.active};
              }
            }
          }

          [data-testid='validations-modal'] button {
            &:not([disabled]) {
              color: ${color.foreground.default};
              border-color: ${color.stroke.informative.default};

              &:hover {
                color: ${color.foreground.default};
                border-color: ${color.stroke.informative.default};
              }

              &:active {
                background-color: ${color.primary.background.active};
              }
            }
          }

          [data-testid='shipping-form'],
          [data-testid='ftm-shipping-step'] {
            input:focus,
            textarea:focus,
            [class*='InputField']:focus,
            [class*='FormControl']:focus-within {
              border-color: ${color.primary.base.default} !important;
            }

            [class*='InputField']:focus-within,
            [class*='FormControl']:focus-within {
              border-color: ${color.primary.base.default} !important;
            }
          }
        }
      `}
  }
`
